<template>
  <div class="chipsButton shadow100" :class="buttonClass" @click="click">
    <!-- Tooltip 1 -->
    <Tooltip
      :tWidth="260"
      :tBottom="-92"
      :avatar="true"
      :hand="true"
      v-if="index === 0 && $store.state.tutStep === 1"
      >Great! Now spend some money on upgrades</Tooltip
    >

    <!-- Tooltip 2 -->
    <Tooltip
      :tWidth="260"
      :tBottom="-92"
      :avatar="true"
      :hand="true"
      v-if="
        index === 1 && $store.state.tutStep === 3 && $store.state.money >= 10
      "
      >Buy new productions to earn more money!</Tooltip
    >

    <span class="body2"><slot></slot></span>
    <div class="chip body2">{{ fPrice }}</div>
  </div>
</template>

<script>
import itemsProdJson from "@/assets/data/prodItems.json";
import itemsMedJson from "@/assets/data/medItems.json";
import Tooltip from "@/components/Tooltip.vue";

export default {
  name: "Prod Item",
  components: { Tooltip },
  props: {
    item: String,
    price: Number,
    index: Number,
    action: String,
    med: Boolean,
  },

  emits: ["bought", "event"],

  computed: {
    buttonClass: function() {
      // when has enough money, and disabled on prod when lockdown
      if (this.$store.state.money >= this.price) {
        if (this.med) {
          return ["active", this.action];
        } else if (this.$store.state.lockdown) {
          return ["inactive", this.action];
        } else {
          return ["active", this.action];
        }
      } else {
        return ["inactive", this.action];
      }
    },

    fPrice: function() {
      return this.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

  mounted: function() {},

  methods: {
    click: function() {
      this.$store.commit("minusMoney", this.price);

      switch (this.action) {
        case "buy":
          this.$emit("bought"); // logically not necessary, just to fix some weird rare bug
          if (this.med) {
            this.$store.commit("enableMedItem", this.index);
            this.track("Item", "Med Item", "Enabled Med: " + this.index);

            if (
              this.$store.state.medItems.length !== itemsMedJson.items.length
            ) {
              this.$store.dispatch("loadMedItem", this.index + 1);
            }
          } else {
            this.track("Item", "Prod Item", "Enabled Prod: " + this.index);
            this.$store.commit("enableProdItem", this.index);
            if (
              this.$store.state.prodItems.length !== itemsProdJson.items.length
            ) {
              this.$store.dispatch("loadProdItem", this.index + 1);
            }
          }

          break;

        case "upgrade":
          this.med
            ? this.$store.commit("levelMedUp", this.index)
            : this.$store.commit("levelProdUp", this.index);

          break;

        case "UnlockVaccine":
          this.$emit("event", "Started");
          break;
      }
      // tutorial
      if (this.$store.state.tutStep === 1 && this.index === 0) {
        this.track("2nd Step", "Onboarding");
        this.$store.commit("plusTutStep");
      }

      if (this.$store.state.tutStep === 3 && this.index === 1) {
        this.track("4th Step", "Onboarding");
        this.$store.commit("plusTutStep");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";

.chipsButton {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 4px 4px 24px;
  border-radius: 100px;
  text-transform: uppercase;
  transition: all 0.2s;
  position: relative;

  .chip {
    padding: 4px 12px;
  }
}

.inactive {
  background: $gray800;
  border: 1px solid $gray800;
  color: #fff;
  pointer-events: none;

  .chip {
    background: #fff;
    border-radius: 100px;
    color: $gray800;
    margin-left: 8px;
  }
}

.active {
  background: $blue;
  border: 1px solid $blue;
  color: #fff;
  box-shadow: 0px 0px 8px rgba(103, 103, 103, 0.2);

  .chip {
    background: #fff;
    border-radius: 100px;
    color: $blue;
    margin-left: 8px;
  }
}

.item {
  .active.upgrade {
    background: #fff;
    color: $blue;
    border: 1px solid $blue;

    .chip {
      background: $blue;
      color: #fff;
    }
  }
}
</style>
